import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import CustomAvailabilityListItem from './custom-availability-list-item'

const CustomAvailabilityList = ({ overrides, refetch }) => {
  if (overrides.length === 0) {
    return (
      <Box py={2}>
        <Typography variant="body2" color="textSecondary">
          No custom availability overrides have been added yet.
        </Typography>
      </Box>
    )
  }

  return (
    <Box>
      {overrides.map(override => (
        <CustomAvailabilityListItem
          key={override.id}
          override={override}
          onDestroySuccess={refetch}
        />
      ))}
    </Box>
  )
}

export default CustomAvailabilityList
